<template>
  <v-container grid-list-xs fluid>
    <div class="pageHeader">
      <div class="d-flex align-center flex-row">
        <div class="me-4" v-if="$vuetify.breakpoint.mdAndUp">
          <Icon size="56" icon="Auto" color="switchq" />
        </div>
        <div class="d-flex flex-column">
          <div>
            <h1 class="switchq--text">{{ $t("links.automations") }}</h1>
          </div>
          <div v-if="!newCreate" class="d-flex flex-row align-center">
            <v-chip
              outlined
              color="grey darken-1"
              class="font-weight-black me-2"
              >{{ $t("total") }}: {{ automations.length }}</v-chip
            >
            <v-chip outlined color="success" class="font-weight-black me-2"
              >{{ $t("actives") }}:
              {{ automations.filter((a) => a.status).length }}</v-chip
            >
            <v-chip outlined color="warning" class="font-weight-black me-2"
              >{{ $t("non-actives") }}:
              {{ automations.filter((a) => !a.status).length }}</v-chip
            >
          </div>
        </div>
      </div>
      <v-btn
        v-if="
          !newCreate && $userPermissions.permitted('create-user-automations')
        "
        color="info"
        d-flex
        align-center
        :block="$vuetify.breakpoint.xs"
        outlined
        @click="newCreate == false ? (newCreate = true) : ''"
      >
        <v-icon class="me-2">add</v-icon>
        {{ $t("newAuto") }}
      </v-btn>
    </div>
    <v-layout row wrap class="mt-5">
      <v-flex xs12>
        <v-stepper v-model="e1" v-show="newCreate">
          <v-stepper-header>
            <v-stepper-step
              :class="e1 > 1 ? 'pointer' : ''"
              @click="e1 > 1 ? (e1 = 1) : null"
              :complete="e1 > 1"
              step="1"
            >
              <div>
                {{ $t("auto-name") }}
              </div>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :class="e1 > 2 ? 'pointer' : ''"
              @click="e1 > 2 ? (e1 = 2) : null"
              :complete="e1 > 2"
              step="2"
            >
              {{ $t("when") }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :class="e1 > 3 ? 'pointer' : ''"
              @click="e1 > 3 ? (e1 = 3) : null"
              :complete="e1 > 3"
              step="3"
            >
              {{ $t("then") }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4">
              {{ $t("end") }}
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12" color="grey lighten-3" height="200px">
                <v-text-field
                  class="autoNameField"
                  type="String"
                  :label="$t('auto-name')"
                  v-model="autoName"
                ></v-text-field>
              </v-card>
              <v-flex row justify-space-around>
                <v-btn
                  outlined
                  color="primary"
                  @click="autoName ? (e1 = 2) : alertError('mustName')"
                >
                  {{ $t("next") }}
                </v-btn>

                <v-btn outlined @click="cancelAction">
                  {{ $t("cancel") }}
                </v-btn>
              </v-flex>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-layout v-if="$vuetify.breakpoint.xs" row wrap justify-start>
                <h3>{{ $t("when") }}</h3>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-btn
                  @click="addIf = true"
                  block
                  v-show="!addIf && !configIfs"
                  class="my-3"
                >
                  {{ $t("addIf") }}
                </v-btn>
              </v-layout>
              <automations-ifs
                v-if="addIf && !configIfs"
                @createNewIf="(data) => createIf(data)"
                @closeForm="addIf = false"
              />
              <v-layout
                v-show="!addIf && !configIfs"
                justify-center
                row
                wrap
                v-for="(item, index) in ifs"
                :key="index"
              >
                <v-card
                  elevation="2"
                  class="my-2 d-flex flex-row edit-row-content"
                >
                  <v-card-text class="pa-0">
                    <if-row-content :ifRow="item" />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text icon color="info" @click="editIf(item, index)">
                      <Icon icon="edit" />
                    </v-btn>
                    <v-btn text icon color="red" @click="removeIf(index)">
                      <Icon icon="deleteIcon" />
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-layout>
              <automations-ifs
                :config="configIfs"
                :configData="configIfData"
                :index="configIfIndex"
                v-if="configIfs && !addIf"
                @updateNewIf="(data) => updateIf(data)"
                @closeForm="
                  (configIfs = false),
                    (configIfData = null),
                    (configIfIndex = null)
                "
              />
              <v-layout
                v-show="!addIf && !configIfs"
                column
                wrap
                justify-center
                align-center
                class="my-4 mb-2"
              >
                <!-- v-show="this.ifType" -->
                <v-checkbox
                  label="השהיה לפני ביצוע הפעולות (בשניות)"
                  v-model="ifDelay"
                ></v-checkbox>
                <v-text-field
                  v-if="ifDelay"
                  type="Number"
                  :label="$t('seconds')"
                  v-model="delayTime"
                ></v-text-field>
              </v-layout>
              <v-flex v-show="!addIf && !configIfs" row justify-space-around>
                <v-btn
                  outlined
                  :disabled="ifs.length == 0"
                  color="primary"
                  @click="e1 = 3"
                >
                  {{ $t("next") }}
                </v-btn>
                <v-btn outlined @click="e1 = 1">
                  <!-- <v-btn @click="cancelAction"> -->
                  {{ $t("back") }}
                </v-btn>
              </v-flex>
              <v-flex
                class="mt-4"
                v-show="!addIf && !configIfs"
                row
                justify-center
              >
                <v-btn text @click="cancelAction">
                  {{ $t("cancel") }}
                </v-btn>
              </v-flex>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-layout v-if="$vuetify.breakpoint.xs" row wrap justify-start>
                <h3>{{ $t("then") }}</h3>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-btn
                  @click="addThen = true"
                  block
                  v-show="!addThen && !configThens"
                  class="my-3"
                >
                  {{ $t("addAction") }}
                </v-btn>
              </v-layout>
              <automations-thens
                v-if="addThen && !configThens"
                @createNewThen="(data) => createThen(data)"
                @closeForm="addThen = false"
              />
              <v-layout
                v-show="!addThen && !configThens"
                justify-center
                row
                wrap
                v-for="(item, index) in thens"
                :key="index"
              >
                <v-card elevation="2" class="my-2 d-flex flex-row">
                  <v-card-text>
                    {{ item.then_action ? $t("deviceAction") : $t("sendMsg") }}:
                    {{
                      item.then_controller
                        ? device(item.then_controller).name
                          ? device(item.then_controller).name +
                            " " +
                            $t("status") +
                            " " +
                            $t(item.then_action)
                          : device(item.then_controller).identifier +
                            " " +
                            $t("status") +
                            " " +
                            $t(item.then_action)
                        : $t("via") + " " + $t(item.then_notify.not)
                    }}
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      text
                      icon
                      color="info"
                      @click="editThen(item, index)"
                    >
                      <Icon icon="edit" />
                    </v-btn>
                    <v-btn text icon color="red" @click="removeThen(index)">
                      <Icon icon="deleteIcon" />
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-layout>
              <automations-thens
                :config="configThens"
                :configData="configThenData"
                :index="configThenIndex"
                v-if="configThens && !addThen"
                @updateNewThen="(data) => updateThen(data)"
                @closeForm="
                  (configThens = false),
                    (configThenData = null),
                    (configThenIndex = null)
                "
              />
              <v-flex
                row
                v-show="!addThen && !configThens"
                justify-space-around
              >
                <v-btn
                  outlined
                  :disabled="thens.length == 0"
                  color="primary"
                  @click="e1 = 4"
                >
                  {{ $t("next") }}
                </v-btn>

                <v-btn outlined @click="e1 = 2">
                  {{ $t("back") }}
                </v-btn>
              </v-flex>
              <v-flex
                class="mt-4"
                v-show="!addThen && !configThens"
                row
                justify-center
              >
                <v-btn text @click="cancelAction">
                  {{ $t("cancel") }}
                </v-btn>
              </v-flex>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-layout v-if="$vuetify.breakpoint.xs" row wrap justify-start>
                <h3>{{ $t("end") }}</h3>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-btn
                  @click="addEnd = true"
                  block
                  v-show="!addEnd && !configEnds"
                  class="my-3"
                >
                  {{ $t("addAction") }}
                </v-btn>
              </v-layout>
              <automations-ends
                v-if="addEnd && !configEnds"
                @createNewEnd="(data) => createEnd(data)"
                @closeForm="addEnd = false"
              />
              <v-layout
                v-show="!addEnd && !configEnds"
                justify-center
                row
                wrap
                v-for="(item, index) in ends"
                :key="index"
              >
                <v-card elevation="2" class="my-2 d-flex flex-row">
                  <v-card-text>
                    {{ item.end_action ? $t("deviceAction") : $t("sendMsg") }}:
                    {{
                      item.end_controller
                        ? device(item.end_controller).name
                          ? device(item.end_controller).name +
                            " " +
                            $t("status") +
                            " " +
                            $t(item.end_action)
                          : device(item.end_controller).identifier +
                            " " +
                            $t("status") +
                            " " +
                            $t(item.end_action)
                        : $t("via") + " " + $t(item.end_notify.not)
                    }}
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text icon color="info" @click="editEnd(item, index)">
                      <Icon icon="edit" />
                    </v-btn>
                    <v-btn text icon color="red" @click="removeEnd(index)">
                      <Icon icon="deleteIcon" />
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-layout>
              <automations-ends
                :config="configEnds"
                :configData="configEndData"
                :index="configEndIndex"
                v-if="configEnds && !addEnd"
                @updateNewEnd="(data) => updateEnd(data)"
                @closeForm="
                  (configEnds = false),
                    (configEndData = null),
                    (configEndIndex = null)
                "
              />

              <v-flex v-show="!addEnd && !configEnds" row justify-space-around>
                <v-btn color="primary" @click="confirm()">
                  {{ $t("confirm") }}
                </v-btn>

                <v-btn @click="e1 = 3">
                  {{ $t("back") }}
                </v-btn>
              </v-flex>
              <v-flex
                class="mt-4"
                v-show="!addEnd && !configEnds"
                row
                justify-center
              >
                <v-btn text @click="cancelAction">
                  {{ $t("cancel") }}
                </v-btn>
              </v-flex>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
    <v-container v-if="!newCreate" container-fluid>
      <div class="automationsContainer">
        <!-- <div class="d-flex flex-wrap flex-row justify-space-between align-center"> -->
        <v-card
          class="automationCard"
          v-for="(auto, index) in automations"
          :key="index"
        >
          <div
            class="automationCard-header"
            @click="
              $vuetify.breakpoint.smAndDown
                ? openAutomationModal(auto.uuid)
                : null
            "
          >
            <div
              class="automationCard-header-title pointer"
              @click="openAutomationModal(auto.uuid)"
            >
              <h3>{{ auto.name }}</h3>
            </div>
            <div
              v-if="$vuetify.breakpoint.mdAndUp"
              class="automationCard-header-actions"
            >
              <div class="mb-2 d-flex align-center">
                <v-btn
                  color="red"
                  icon
                  class="me-2"
                  @click="deleteAutomation = auto.uuid"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  v-if="$userPermissions.permitted('edit-user-automations')"
                  color="blue darken-2"
                  icon
                  @click="editAuto(auto)"
                >
                  <v-icon>settings</v-icon>
                </v-btn>
              </div>
              <!-- :prepend-icon="auto.status ? 'mdi-flash' : 'mdi-flash-off'" -->
              <v-switch
                :disabled="!$userPermissions.permitted('edit-user-automations')"
                v-model="auto.status"
                color="success"
                :false-value="auto.status == 0"
                inset
                hide-details
                @click="toggleAutomation(auto)"
              >
              </v-switch>
            </div>
          </div>
          <div
            class="d-flex flex-row justify-start align-center mt-4"
            @click="
              $vuetify.breakpoint.smAndDown
                ? openAutomationModal(auto.uuid)
                : null
            "
          >
            <v-chip color="blue" outlined class="me-3">
              {{ auto.automation_ifs.length }} {{ $t("when") }}
            </v-chip>
            <v-chip color="purple" outlined class="me-3">
              {{ auto.automation_thens.length }} {{ $t("then") }}
            </v-chip>
            <v-chip
              v-if="auto.automation_ends && auto.automation_ends.length"
              color="orange"
              outlined
              class="me-3"
            >
              {{ auto.automation_ends.length }} {{ $t("end") }}
            </v-chip>
          </div>
          <div
            v-if="$vuetify.breakpoint.mdAndUp"
            class="d-flex justify-center align-center mt-4"
            @click="openAutomationModal(auto.uuid)"
          >
            <v-btn color="purple darken-2" text>{{ $t("openIt") }}</v-btn>
          </div>
        </v-card>
      </div>
    </v-container>
    <Modal
      :activator="!!deleteAutomation"
      @close="deleteAutomation = null"
      @delete="deleteAuto"
    />
    <automationDetailsModal
      v-if="!!automationDetailsModalUuid"
      :dialog="!!automationDetailsModalUuid"
      :uuid="automationDetailsModalUuid"
      @close="automationDetailsModalUuid = null"
      @edit="editAutoByUuid(automationDetailsModalUuid)"
      @delete="deleteAuto(automationDetailsModalUuid)"
    />
  </v-container>
</template>
<script>
import Modal from "@/components/general/DeleteModal.vue";
import AutomationsIfs from "./automationsIfs.vue";
import automationsThens from "./automationsThens.vue";
import automationsEnds from "./automationsEnds.vue";
import automationDetailsModal from "../automations/automationDetailsModal.vue";
import ifRowContent from "../automations/ifRowContent.vue";
export default {
  name: "automations",
  components: {
    Modal,
    AutomationsIfs,
    automationsThens,
    automationsEnds,
    automationDetailsModal,
    ifRowContent,
  },
  data() {
    return {
      configThenData: null,
      configThenIndex: null,
      configThens: false,
      configEndData: null,
      configEndIndex: null,
      configEnds: false,
      configIfData: null,
      configIfIndex: null,
      configIfs: false,
      delayTime: null,
      ifDelay: false,
      addIf: false,
      addThen: false,
      addEnd: false,
      ifs: [],
      thens: [],
      ends: [],
      newCreate: false,
      autoName: null,
      deviceSelector: [],
      e1: 1,
      deleteAutomation: null,
      editAutomation: null,
      automationDetailsModalUuid: null,
    };
  },
  mounted() {
    this.devices;
  },
  computed: {
    automations() {
      let automations = this.$store.getters["automations/automationsObj"];
      return Object.values(automations);
    },
    devices() {
      let devices = this.$store.getters["devices/devices"];
      // Object.values(devices).filter((d) => {
      // console.log("devicessssssssssss", devices);
      //   // if (d) {
      //   return d.role == 0 &&
      //     ("temperatures" in d.data.sensors || "humidity" in d.data.sensors)
      //     ? this.deviceSelector.push({
      //         name: d.name,
      //         slug: d.slug,
      //         identifier: d.identifier,
      //         sensors: d ? Object.keys(d.data.sensors) : [],
      //         type: d.settings.sensor_type,
      //       })
      //     : "";
      //   // }
      // });
      return Object.values(devices)
        .filter((d) => {
          // console.log("ddddddd", d);
          // if (d) {
          return d.role == 0 &&
            d.data &&
            d.data.sensors &&
            ("temperatures" in d.data.sensors || "humidity" in d.data.sensors)
            ? this.deviceSelector.push({
                name: d.name,
                slug: d.slug,
                identifier: d.identifier,
                sensors: d ? Object.keys(d.data.sensors) : [],
                type: d.settings.sensor_type,
              })
            : "";
          // }
        })
        .map((d) => {
          // if (d) {
          return {
            name: d.name,
            slug: d.slug,
            identifier: d.identifier,
            sensors:
              d && d.data && "sensors" in d.data
                ? Object.keys(d.data.sensors)
                : [],
            type: d.settings.sensor_type,
          };
          // }
        });
    },
    sensorDevices() {
      let sensors = [
        {
          value: "temperatures",
          text: this.$t("temperature"),
        },
        {
          value: "humidity",
          text: this.$t("humidity"),
        },
        {
          value: "range",
          text: this.$t("range"),
        },
      ];
      if (this.sensorVal) {
        const deviceSensors = this.devices.filter(
          (d) => d.identifier == this.sensorVal
        )[0].sensors;
        return sensors.filter((s) => deviceSensors.includes(s.value));
      } else {
        return [];
      }
    },
    actions() {
      return [
        {
          value: ">",
          text: this.$t("bigger"),
        },
        {
          value: "<",
          text: this.$t("smaller"),
        },
        {
          value: "==",
          text: this.$t("equals"),
        },
        {
          value: "!=",
          text: this.$t("not-equals"),
        },
      ];
    },
  },
  methods: {
    async getAutos() {
      await this.$store.dispatch("automations/getAutomations");
    },
    editEnd(item, index) {
      this.configEnds = true;
      this.configEndData = item;
      this.configEndIndex = index;
    },
    editThen(item, index) {
      this.configThens = true;
      this.configThenData = item;
      this.configThenIndex = index;
    },
    editIf(item, index) {
      // console.log("item", item);
      // console.log("index", index);
      this.configIfs = true;
      this.configIfData = item;
      this.configIfIndex = index;
    },
    editAuto(auto) {
      this.autoName = auto.name;
      this.ifDelay = auto.delay_time ? true : false;
      this.delayTime = auto.delay_time ? auto.delay_time : null;
      this.ifs = [...auto.automation_ifs];
      this.thens = [...auto.automation_thens];
      this.ends = [...(auto.automation_ends ?? [])];
      this.newCreate = true;
      this.editAutomation = auto.uuid;
    },
    editAutoByUuid(uuid) {
      const auto = this.automations.filter((a) => a.uuid == uuid)[0];
      this.automationDetailsModalUuid = null;
      this.editAuto(auto);
    },
    createIf(data) {
      this.ifs.push(data);
    },
    updateIf(data) {
      this.ifs[this.configIfIndex] = data;
      this.configIfData = null;
      this.configIfIndex = null;
      this.configIfs = false;
    },
    createThen(data) {
      this.thens.push(data);
    },
    updateThen(data) {
      this.thens[this.configThenIndex] = data;
      this.configThenData = null;
      this.configThenIndex = null;
      this.configThens = false;
    },
    createEnd(data) {
      this.ends.push(data);
    },
    updateEnd(data) {
      this.ends[this.configEndIndex] = data;
      this.configEndData = null;
      this.configEndIndex = null;
      this.configEnds = false;
    },
    removeIf(i) {
      this.ifs.splice(i, 1);
    },
    removeThen(i) {
      this.thens.splice(i, 1);
    },
    removeEnd(i) {
      this.ends.splice(i, 1);
    },
    device(identifier) {
      return this.devices.filter((d) => d.identifier == identifier)[0];
    },
    action(val) {
      return this.actions.filter((a) => a.value == val)[0];
    },
    alertError(msg) {
      this.$store.dispatch("general/setAlert", {
        type: "oops",
        msg: msg,
      });
    },
    async deleteAuto(uuid) {
      if (uuid) {
        this.deleteAutomation = uuid;
      } else if (this.deleteAutomation) {
        this.automationDetailsModalUuid = null;
        await this.$store.dispatch(
          "automations/deleteAutomation",
          this.deleteAutomation
        );
        this.deleteAutomation = null;
      }
    },
    cancelAction() {
      this.newCreate = false;
      this.editAutomation = null;
      this.autoName = null;
      this.e1 = 1;
      this.ifs = [];
      this.thens = [];
      this.ends = [];
      this.ifDelay = false;
      this.delayTime = null;
      this.addIf = false;
      this.addThen = false;
      this.addEnd = false;
      this.configIfData = null;
      this.configIfIndex = null;
      this.configIfs = false;
      this.configThenData = null;
      this.configThenIndex = null;
      this.configThens = false;
      this.configEndData = null;
      this.configEndIndex = null;
      this.configEnds = false;
    },
    async confirm() {
      let data = {};
      if (
        this.ifs.length != 0 &&
        this.thens.length != 0 &&
        this.autoName != null
      ) {
        data = {
          autoName: this.autoName,
          delay_time:
            this.ifDelay && this.delayTime ? parseInt(this.delayTime) : null,
          ifs: this.ifs,
          thens: this.thens,
          ends: this.ends.length > 0 ? this.ends : null,
        };
        if (this.editAutomation) {
          data.uuid = this.editAutomation;
          await this.$store.dispatch("automations/updateAutomation", data);
        } else {
          await this.$store.dispatch("automations/setAutomation", data);
        }
        this.cancelAction();
      } else {
        this.alertError(this.$t("Check-required-fields"));
      }
    },
    async toggleAutomation(auto) {
      await this.$store.dispatch("automations/toggleAutomation", auto);
    },
    openAutomationModal(uuid) {
      this.automationDetailsModalUuid = uuid;
    },
  },
};
</script>
<style lang="scss" scoped>
.pageHeader {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  padding: 32px;
  border-radius: 30px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  h1 {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
    padding: 0px 4px 16px 4px;
  }
}
.vertDivider {
  color: red;
}

.v-stepper-content,
.v-stepper__content {
  max-width: 840px;
  margin: 0 auto;
}

.autoNameField {
  margin: 0 auto;
  padding-top: 50px;
  width: 85%;
}

.selectors {
  padding-top: 20px;
  margin: 0 auto;
  width: 85%;
}

.automationsContainer {
  display: grid;
  gap: 48px;
  grid-template-columns: repeat(auto-fit, minmax(326px, 1fr));
  justify-content: space-evenly;
}
.edit-row-content {
  width: 100%;
  max-width: 700px;
}
.automationCard {
  min-height: 100px;
  border-radius: 30px;
  padding: 32px 28px 16px 28px;
  position: relative;
  overflow: hidden;
  .automationCard-header {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .automationCard-header-title {
      h3 {
        max-height: 76px;
        overflow: hidden;
        text-overflow: ellipsis;
        /* Apply fading mask */
        -webkit-mask-image: linear-gradient(
          to bottom,
          black 75%,
          transparent 100%
        );
        mask-image: linear-gradient(to bottom, black 75%, transparent 100%);
      }
    }
    .automationCard-header-actions {
      margin-top: 8px;
      min-width: 108px;
      min-height: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15px;
    background: rgba(122, 0, 204, 0.4);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
@media screen and (max-width: 600px) {
  .v-stepper-content,
  .v-stepper__content {
    padding: 8px;
  }
  .pageHeader {
    flex-direction: column;
    gap: 24px;
  }
  .automationsContainer {
    gap: 16px;
  }
  .automationCard {
    min-height: 80px;
    padding: 28px 32px 28px 16px;
    &::before {
      height: 10px;
    }
    .automationCard-header {
      .automationCard-header-actions {
        min-width: 0;
        min-height: 0;
      }
    }
    &::before {
      top: 0;
      left: initial;
      right: 0;
      height: 100%;
      width: 15px;
    }
  }
}

.autoCard {
  min-height: 60px;
  width: 85%;
  background-color: #fff;
  text-align: start;
  .v-card__title {
    margin-inline-start: -14px;
    margin-inline-end: -14px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }
  .delIcon {
    display: flex;
    align-items: center;
    .v-icon {
      cursor: pointer;
      color: red;
    }
  }
}
.v-input--selection-controls {
  margin-top: unset;
  padding-top: unset;
}
</style>
